import React, {useCallback, useEffect, useState} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {freezeOmtWithHonee, getTokenFreezeData, setFreezeOmtModalStatus} from "../../store/cabinet/action";
import 'react-toastify/dist/ReactToastify.css';
import {useTranslation} from "react-i18next";


const FreezeOmtHoneeModal = () => {
    const dispatch = useDispatch();
    const freezeOmtHoneeModalStatus = useSelector(store => store.cabinet.freezeOmtHoneeModalStatus);
    const freezeOmtWithHoneeStatusStarted = useSelector(store => store.cabinet.freezeOmtWithHoneeStatusStarted);
    const freezeOmtWithHoneeStatus = useSelector(store => store.cabinet.freezeOmtWithHoneeStatus);

    const tokenFreezeData  = useSelector(store => store.cabinet.tokenFreezeData);
    const { t } = useTranslation();

    const [amount, setAmount] = useState('');
    const [currentPeriodId, setCurrentPeriodId] = useState(false);

    const closeModal = useCallback(() => {
        setAmount('');
        setCurrentPeriodId(false);
        dispatch(setFreezeOmtModalStatus(false));
    }, [dispatch]);

    // ---- санитайзер инпута
    const onAmountChange = (e) => {
        let v = e.target.value.replace(',', '.');   // запятая -> точка
        v = v.replace(/[^\d.]/g, '');               // только цифры и точка

        if (v === '') { setAmount(''); return; }

        // оставить только одну точку
        const partsOnce = v.split('.');
        if (partsOnce.length > 2) {
            v = partsOnce[0] + '.' + partsOnce.slice(1).join('').replace(/\./g, '');
        }

        // если начинается с точки -> "0."
        if (v[0] === '.') v = '0' + v;

        // нормализация лидирующих нулей
        const parts = v.split('.');
        if (parts.length === 1) {
            // целое число
            let int = parts[0].replace(/^0+(?!$)/, ''); // убираем ведущие нули, но оставляем одиночный "0"
            if (int === '') int = '0';
            v = int;
        } else {
            // число с дробной частью
            let [int, frac] = parts;
            int = int.replace(/^0+(?!$)/, '');
            if (int === '') int = '0';
            v = int + '.' + frac;
        }

        setAmount(v);
    };

    const amountNum = Number(amount);
    const isAmountPositive = !!amount && !Number.isNaN(amountNum) && amountNum > 0;

    const mainBtnHandler =  () => {
        dispatch(freezeOmtWithHonee({amount, period_id: currentPeriodId}));
    };

    useEffect(()=>{
        if (tokenFreezeData){
           setCurrentPeriodId(tokenFreezeData?.periods?.[0].id)
        }
    },[tokenFreezeData])

    useEffect(() => {
        if (freezeOmtHoneeModalStatus) dispatch(getTokenFreezeData());
    }, [freezeOmtHoneeModalStatus, dispatch]);

    useEffect(()=>{
        if (freezeOmtWithHoneeStatus){
            closeModal();
            window.open(`${process.env.REACT_APP_HONEE_URL}/honee`, '_blank', 'noopener,noreferrer');
        }
    },[freezeOmtWithHoneeStatus, closeModal])

    const isButtonDisabled = !isAmountPositive || freezeOmtWithHoneeStatusStarted;

    return (
        <Popup
            open={freezeOmtHoneeModalStatus}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}><div/><div/></div>

                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>{t('Заморозить')} OMT</div>
                    <div className={Styles.inputWrap}>
                        <div className={Styles.inputTitle}>{t('Сумма')}</div>
                        <input
                            type="text"
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]*"
                            value={amount}
                            onChange={onAmountChange}
                            placeholder={t('Введите сумму')}
                        />
                    </div>

                    <div className={Styles.periodWrap}>
                        <div className={Styles.periodTitle}>{t('Выберите период заморозки')}</div>
                        <div className={Styles.periodBox}>
                            {tokenFreezeData?.periods?.map((item, index)=>{
                                return (
                                    <div className={`${Styles.periodItem} ${item.id === currentPeriodId ? Styles.periodItemActive : null}`} key={'period' + index} onClick={()=>{setCurrentPeriodId(item.id)}}>{item.days} {t('дней')}</div>
                                )
                            })}
                        </div>
                    </div>

                    <div
                        className={`${Styles.modalContentWrapMainBtn} ${isButtonDisabled ? Styles.modalContentWrapMainBtnDsb : null}`}
                        onClick={isButtonDisabled ? undefined : mainBtnHandler}
                        role="button"
                    >
                        {t('Заморозить')}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default FreezeOmtHoneeModal;








